/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import browser from './browser';
import { dom } from '../ws-util';
/**
 * hybrid msg class
 * @class HybridMsg
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsHybrid.msg.show('this is message');
 * WSLib.wsHybrid.msg.show('success', 'this is success message');
 */
class HybridMsg {
  constructor() {
    this.timeId = undefined;
    this.mIcon = {
      success: 'hook',
      fail: 'cancel',
      info: 'info',
      loading: 'loading',
      noicon: 'noIcon',
    };
    this.styleTxt = [
      '<style type="text/css" id="q_Msgbox_Style">',
      '.gb-tips {position:fixed;width:100%;top:30%;text-align:center;z-index:9999;font-size:14px}',
      '.gb-tips .gb-tips-layer {position:relative;display:inline-block;max-width:54%;padding:8px 10px 8px 38px;text-align:left;line-height:22px;background:rgba(0,0,0,.7);color:#fff;border-radius:5px;max-width:220px}',
      '.gb-tips .gb-tips-layer.no-icon {padding:8px 10px}',
      '.gb-tips .gb-tips-layer .icon-hook {position:absolute;top:12px;left:12px;width:17px;height:12px;background-image:url(//qzonestyle.gtimg.cn/qz-act/public/mobile/img/tick-white.png?max_age=19830212&d=20130918105242);background-size:17px 12px}',
      '.gb-tips .gb-tips-layer .icon-info {position:absolute;top:7px;left:7px;width:24px;height:24px;background-image:url(//qzonestyle.gtimg.cn/qz-act/public/mobile/img/info-white.png?max_age=19830212&d=20130918105242);background-size:24px 24px}',
      '.gb-tips .gb-tips-layer .icon-cancel {position:absolute;left:12px;top:11px;width:16px;height:16px;background-image:url(//qzonestyle.gtimg.cn/qz-act/public/mobile/img/close-white.png?max_age=19830212&d=20130918105242);background-size:16px 16px}',
      '.gb-tips .gb-tips-layer .icon-loading {position:absolute;top:3px;left:3px;height:32px;width:32px;background:url(//qzonestyle.gtimg.cn/qz-proj/weishi-mobile/img/loading.gif?max_age=19830212&d=20130918105242) center center no-repeat;background-size:20px 20px;-webkit-animation:mask 600ms infinite step-start;-moz-animation:mask 600ms infinite step-start;-ms-animation:mask 600ms infinite step-start;-o-animation:mask 600ms infinite step-start;animation:mask 600ms infinite step-start}',
      '</style>',
    ].join('\n');
  }

  /**
   * show message
   * @param {String} type message type [success|fail|info|loading|noicon]
   * @param {String} content message content
   * @param {Number} delay message display time(ms), default 2000ms
   * @param {Object} options display options
   * @param {Boolean} options.middle display options middle
   * @param {Boolean} options.vertical display options vertical
   */
  show(type, content, delay, options) {
    // 提示前，如果有另外一个提示框存在，清除定时器，立即销毁
    if (this.timeId) {
      clearTimeout(this.timeId);
    }
    this.hide();
    // 只有一个参数时，默认为内容，info提示
    if (arguments.length === 1) {
      content = type;
      type = undefined;
    }

    if (!delay && !options && (browser.client === 'qq') && window.mqq) {
      // 默认为3
      let iconMode = 3;
      if (type === 'succ') {
        iconMode = 1;
      } else if (type === 'fail') {
        iconMode = 2;
      }
      if (window.mqq.ui && window.mqq.ui.showTips) {
        window.mqq.ui.showTips({
          text: content,
          iconMode,
        });
      }
    }

    options = options || {};

    let top = '200px';
    if (options.middle) {
      top = `${(window.innerHeight / 2) - 38}px`;
    }
    if (options.vertical) {
      top = '50%';
    }

    document.head.appendChild(dom.str2dom(this.styleTxt));
    document.body.appendChild(this.addTip({
      icon: this.mIcon[type] || this.mIcon.info,
      content: content || '',
      vertical: options.vertical,
      top,
    }));

    this.timeId = setTimeout(this.hide, delay || 2000);
  }

  /**
   * hide message
   */
  hide() {
    const msgBox = document.querySelector('#q_Msgbox');
    const msgBoxStyle = document.querySelector('#q_Msgbox_Style');
    if (msgBox) {
      // msgBox.style = 'none';
      document.body.removeChild(msgBox);
    }
    if (msgBoxStyle) {
      document.head.removeChild(msgBoxStyle);
    }
  }

  /**
   * log message
   * @param {String} msg message
   */
  log(msg) {
    new Image().src = `//www.qq.com/log?log=${msg}`;
  }

  addTip(opts) {
    const htmlStr = `<div class="gb-tips" id="q_Msgbox" ><div class="gb-tips-layer"><i></i>${this.encodeHtml(opts.content)}</div></div>`;
    const $msg = dom.str2dom(htmlStr);

    if (opts.icon === 'noIcon') {
      $msg.querySelector('.gb-tips-layer').classList.add('no-icon');
    } else {
      $msg.querySelector('i').classList.add(`icon-${opts.icon}`);
    }

    if (opts.vertical) {
      $msg.querySelector('.gb-tips-layer').style.transform = 'rotateZ(90deg) translateY(-50%)';
    }

    $msg.style.top = opts.top;

    return $msg;
  }

  encodeHtml(str) {
    return (`${str}`).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\x60/g, '&#96;')
      .replace(/\x27/g, '&#39;')
      .replace(/\x22/g, '&quot;'); // 分别代表` ' "
  }
}

export default new HybridMsg();
